import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type WhosCloseSortDirection = "asc" | "desc";

/**
 * Redux state interface for Who's Close Action Report.
 *
 * @interface WhosCloseARState
 * @property {WhosCloseSortDirection} sortDirection - Current sort direction for bonus percent groups
 * @property {string[]} availableKpis - List of available KPIs for the report
 * @property {string[]} affAbosToExpand - List of AFF-ABO identifiers to expand in tree view
 */
interface WhosCloseARState {
  sortDirection: WhosCloseSortDirection;
  availableKpis: string[];
  affAbosToExpand: string[];
}

export const initialState: WhosCloseARState = {
  sortDirection: "desc",
  availableKpis: [],
  affAbosToExpand: [],
};

const { actions, reducer } = createSlice({
  name: "whosCloseActionReport",
  initialState,
  reducers: {
    setSortDirection: (state, action: PayloadAction<WhosCloseSortDirection>) => {
      state.sortDirection = action.payload;
    },
    toggleSortDirection: (state) => {
      state.sortDirection = state.sortDirection === "asc" ? "desc" : "asc";
    },
    setAvailableKpis: (state, action: PayloadAction<string[]>) => {
      state.availableKpis = action.payload;
    },
    setAffAbosToExpand: (state, action: PayloadAction<string[]>) => {
      state.affAbosToExpand = action.payload;
    },
  },
});

export const { setSortDirection, toggleSortDirection, setAvailableKpis, setAffAbosToExpand } = actions;

export default reducer;
